import { Form } from 'antd';
import { useTransportMileageFiltersStore } from 'shared/stores/use-transport-mileage-filters';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { StatisticsDateRangePicker } from 'components/statistics/statistics-date-range-picker';
import type { ITransportMileageDatepickerProps } from './types';

export const TransportMileageDatepicker = ({ form }: ITransportMileageDatepickerProps) => {
  const { filters, setFilters } = useTransportMileageFiltersStore();

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  const initialValues = {
    date: filters?.date,
  };

  return (
    <Form form={form} initialValues={initialValues}>
      <StatisticsDateRangePicker
        handleSuccess={handleSuccess}
        presets={['last_7_days', 'last_month', 'last_2_months', 'last_3_months']}
        disabledMonths={3}
      />
    </Form>
  );
};
